<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" aria-labelledby="staticBackdrop">
    <div class="modal-dialog modal-lg" role="document">
      <form class="form">
        <div class="modal-content">
          <div class="modal-body">
            <div class="d-flex justify-content-end mb-5">
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor"/>
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor"/>
                    </svg>
                </span>
              </div>
            </div>
            <div class="row min-h-75vh">
              <Stepper
                  ref="formStepper"
                  :steps="stepNames"
                  id="formStepper"
                  :handle-finish="closeModal"
                  :show-navigation="false"
              >
                <template v-for="(step, index) in formData" :key="index" v-slot:[`step${index+1}`]>
                  <Card container-class="card shadow-none" v-if="!step.repeatable">
                    <p class="fs-4 fs-bolder mb-5"> {{ step.description }} </p>
                    <div class="row">
                      <div class="col-12 col-md-6 col-lg-6 mb-5" v-for="(field, index) in step.fields" :key="index">
                        <Input
                            :key="step.id + field.id"
                            v-bind="{...field, type: 'text'}"
                            is-disabled
                            :name="step.name + '_' +field.name"
                            v-model="field['value']"
                        />
                      </div>
                    </div>
                  </Card>
                  <div v-else>
                    <div class="table-responsive row">
                      <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4">
                        <thead>
                          <tr class="fw-bold fs-6 m-5" style="background-color: #F2F3F4;">
                            <th  v-for="(fieldArray, index) in step.fields[0]" :key="'th'+index" class="w-250px">{{ fieldArray.label }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(field, index) in step.fields" :key="'tr'+index">
                            <td v-for="(el, ind) in field" :key="'td'+ind">
                              <span class="text-muted d-block">{{ el['value'] }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                   
                  </div>
                </template>
              </Stepper>
            </div>
          </div>
          <div class="modal-footer">
            <StepperNavigation
                :step-count="stepCount"
                :activeStep="activeStep"
                @nextStep="nextStep"
                @prevStep="prevStep"
                @handleFinish="closeModal"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import {computed, ref, watch} from "vue";
import Card from "@/components/Card.vue";
import Input from "@/components/Input.vue";
import {Stepper} from "@/Modules/Events/components/Stepper";
import {useStore} from "vuex";
import StepperNavigation from "../Stepper/StepperNavigation.vue";

const store = useStore()

const props = defineProps({
  id: String,
  eventName: String,
  inscription: String
})

const formStepper = ref()
const formData = ref([])
const formErrors = ref({})
const isLoading = ref(true)

const stepNames = computed(() => formData.value.map(el => el.name) || [])
const stepCount = computed(() => formData.value.length)
const activeStep = computed(() => {
  if(!formStepper.value) return 0
  return formStepper.value.activeStep
} )

watch(() => props.inscription, () => {
  loadInscriptionData()
}, { deep: true })

function loadInscriptionData() {
  if(props.inscription) {
    isLoading.value = true
    store.dispatch('events/getEventInscription', props.inscription)
        .then(res => {
          formData.value = Object.values(res.data.data)
        })
        .catch(err => {

        })
        .finally(() => {
          isLoading.value = false
        })
  }
}

function closeModal() {
  $('#'+props.id).modal('toggle')
  if(formStepper.value) {
    formStepper.value.reset()
  }
}
function prevStep() {

  if(formStepper.value) {
    formStepper.value.prevStep()
  }

}
function nextStep() {
  if(formStepper.value) {
    formStepper.value.nextStep()
  }
}
</script>

<style scoped>


@media (min-width: 992px) {
    .modal-lg {
        max-width: 1200px;
    }
}


</style>